import { __extends } from "tslib";
import { fetchSerialNumberLocators } from '@gn-audio/core/api/knowledge-base';
import { GroupRestrictedSpotType } from 'src/Shared/enums/group-restricted-spot-type.enum';
import { ContactSupportSectionController } from 'src/Feature/ContactSupport/app';
var SerialNumberLocatorSpotController = (function (_super) {
    __extends(SerialNumberLocatorSpotController, _super);
    function SerialNumberLocatorSpotController($scope, $q, productContextService, dynamicPagesSpotsDisplayOptionsService) {
        var _this = _super.call(this, $scope, productContextService, dynamicPagesSpotsDisplayOptionsService, GroupRestrictedSpotType.Other) || this;
        _this.$scope = $scope;
        _this.$q = $q;
        return _this;
    }
    SerialNumberLocatorSpotController.prototype.$onInit = function () {
        var _this = this;
        _super.prototype.$onInit.call(this);
        this.$scope.applicableServices = [];
        var $serviceJsonWatcher = this.$scope
            .$watch('serviceJson', function (newValue) {
            if (typeof newValue === 'string') {
                _this.$scope.services = JSON.parse(newValue);
            }
            else {
                _this.$scope.services = [];
            }
            $serviceJsonWatcher();
        });
        this.productContextService
            .subscribe()
            .then(null, null, function (group) {
            if (!group) {
                _this.$scope.applicableServices = [];
                _this.$scope.serialNumberLocators = [];
                return;
            }
            _this.$scope.group = group;
            _this.$scope.promise = _this.$q.when(fetchSerialNumberLocators(group.groupId))
                .then(function (serialNumberLocators) {
                _this.$scope.serialNumberLocators = serialNumberLocators || [];
            }, function () { _this.$scope.serialNumberLocators = []; });
            _this.$scope.applicableServices = _this.$scope.services
                .filter(function (service) {
                return (service.segmentType === '' ||
                    (service.segmentType || '').toLowerCase() === (group.segmentType || '').toLowerCase());
            });
        });
        this.$scope.getServiceSummary = function (service) {
            var _a;
            var productName = ((_a = _this.$scope.group) === null || _a === void 0 ? void 0 : _a.productName) || '';
            return (service.summary || '')
                .replace('{{group.productName}}', productName)
                .replace('{{::group.productName}}', productName);
        };
        this.$scope.hasSerialNumberLocators = function () {
            var snlItems = _this.$scope.serialNumberLocators || [];
            return Array.isArray(snlItems) && snlItems.length > 0;
        };
        this.$scope.hasApplicableServices = function () {
            var services = _this.$scope.applicableServices;
            return Array.isArray(services) && services.length > 0;
        };
    };
    SerialNumberLocatorSpotController.$inject = [
        '$scope',
        '$q',
        'productContextService',
        'dynamicPagesSpotsDisplayOptionsService',
    ];
    return SerialNumberLocatorSpotController;
}(ContactSupportSectionController));
export { SerialNumberLocatorSpotController };
